import {
    CAM_VIEW_CHANGED,
    SET_SINGLE_VIEW,
    SET_CAM_BROWSER_CAM,
    SET_CAM_GROUP_SINGLE,
    SET_CAM_GROUP_QUAD
  } from './types';
import { configChange } from './ConfButtonsActions';
import { getCamViewForConf } from '../reducers/CamButtonsReducer';

export const camViewChange = camset => {
    return {
      type: CAM_VIEW_CHANGED,
      payload: camset
    };
  };

  export const setSingleView = (cam) => {
    return {
      type: SET_SINGLE_VIEW,
      payload: cam
    };
  }

  export const setCameraBrowserCam = cam => {
    return {
      type: SET_CAM_BROWSER_CAM,
      payload: cam
    };
  }

  // used for DVRS with more than 16 cameras
  export const setCamGroupSingle = type => {
    return {
      type: SET_CAM_GROUP_SINGLE,
      payload: type
    };
  }

  // used for DVRS with more than 32 cameras
  export const setCamGroupQuad = type => {
    return {
      type: SET_CAM_GROUP_QUAD,
      payload: type
    };
  }

// changeGridLayout — the ONE grid-layout change: the selected grid (conf) + the camera SET it shows
// (currentCamView) + the cam-group, dispatched TOGETHER so the SHARED grid stays consistent wherever it is
// changed. Live and playback share the grid (#86bb7phhh — only the controls differ), so the playback
// transport picker goes through this exactly like Live's selectGridLayout, and changing the grid in one
// carries to the other (fixes playback->live: the picker used to change conf without the set, leaving
// Live on its stale camera bank). 'conf-fs' is ignored by ConfButtonsReducer, so fullscreen never leaks.
export const changeGridLayout = (conf) => (dispatch) => {
  dispatch(configChange(conf));
  dispatch(camViewChange(getCamViewForConf(conf)));
  if (conf === 'conf-1') dispatch(setCamGroupSingle(1));
  if (conf === 'conf-4') dispatch(setCamGroupQuad(1));
};
